import { ImpactCategoryId } from '@upright/common/model/input/impacts/impact-categories';
import { Dimension } from '@upright/common/model/types';

export interface Bounds {
  x1: number;
  x2: number;
  y1: number;
  y2: number;
  cx: number;
  cy: number;
  width: number;
  height: number;
}

export function isNonEmpty(bounds: Bounds) {
  return bounds.width > 0 && bounds.height > 0;
}

export enum Side {
  LEFT = 1,
  RIGHT = 2,
}

export enum LensBoxMode {
  SIDE,
  FLOAT, // used only be the taxonomy lens
  MODAL,
}

export interface CarouselLayout {
  topDescriptionsArea: () => Bounds & { narrowMode: boolean };
  topTitlesArea: () => Bounds;
  dimensionArea: (dimension: Dimension) => Bounds;
  dimensionCenterArea: (dimension: Dimension) => Bounds;
  dimensionHeadArea: (dimension: Dimension) => Bounds;
  dimensionHeadCenterArea: (dimension: Dimension) => Bounds;
  dimensionHeadDataArea: (side: Side, dimension: Dimension) => Bounds;
  impactArea: (impact: ImpactCategoryId) => Bounds;
  impactCenterArea: (impact: ImpactCategoryId) => Bounds;
  impactDataArea: (side: Side, impact: ImpactCategoryId) => Bounds;
  centerArea: () => Bounds;
  boxesArea: (side: Side) => Bounds;
  lineSpaceArea: (side: Side) => Bounds;
  dataArea: (side: Side) => Bounds;
  aggregateResultArea: () => Bounds;
  fullArea: () => Bounds;
  boxMode: LensBoxMode;
  boxesWidth: number;
  totalSumsDataArea: (side: Side) => Bounds;
  totalSumsTitleArea: () => Bounds;
  additionalInfoArea: (side: Side) => Bounds;
}
